/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	import View = alm.view.View;
	import TweenCSS = alm.util.TweenCSS;
	import Easing = alm.math.Easing;

	export class Ending extends View<JQuery> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor() {
			super(jQuery('#sequence .ending'));

			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():JQuery {
			const view = this.getView();

			this.logo = view.find('.logo');

			return view;
		}

		protected implReady():void {
		}

		protected implFinalize():void {
		}

		protected implShow(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Serial(
				TweenCSS.fadeIn(view, useTransition ? 1000 : 0, Easing.easeOutSine, 'block', false, false),
				new cmd.Wait(useTransition ? 500 : 0),
				TweenCSS.fadeIn(this.logo, useTransition ? 1000 : 0, Easing.easeOutSine, 'block', false, false),
			);
		}

		protected implHide(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.css({ display: 'none', opacity: 0 });
				this.logo.css({ display: 'none', opacity: 0 });
			});
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private logo:JQuery;
	}
}
